'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InertialManager = undefined;

var _src = require('./src');

var _src2 = _interopRequireDefault(_src);

var _InertialManager = require('./src/InertialManager');

var _InertialManager2 = _interopRequireDefault(_InertialManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

exports.default = _src2.default;
exports.InertialManager = _InertialManager2.default;
